import env from "../env";

const API_CONFIG = {
  baseUrl: env.REACT_APP_MGA_BACKEND_API_URL,
  baseUrl_Default: env.REACT_APP_EMB_BACKEND_API_URL,
  baseUrl_User_mgt: env.REACT_APP_USER_MGT_API_URL,
  baseUrl_Simulation: env.REACT_SIMULATION_BACKEND_API_URL,
  endpoints: {
    
    getScope: "auth/getScope",
    logoutAPI: "auth/logout",
    getRegistrationDetails: "auth/registration",
    saveRegistration: "auth/registration",
    getUsers: "auth/getUsers",
    getRoles: "auth/getRoles",
    addUsers: "auth/addUsers",
    projectList: "auth/projects",
    deleteUser: "auth/deleteUser",

  },
  userMgtendpoints: {
    getScope: "/auth/getScope",
    // Fixed stray quote in endpoint path
    profile: "/auth/userInfo",
    getUserInfo:"/auth/getUserInfo",
  },
  mgaendpoints: {
    getCurrency: "/mga/currency",
    checkHealthAPI: "actuator/health",
    mgaProjects: "/mga/projects",
    createProject: "/mga/project",
    mgConfigTypeForUser: "/mga/mgConfigTypeForUser",
    editProjectDetails: "/mga/project",
    getBuildingTypes: "/mga/getBuildingTypes",
    saveComponent: "/mga/component",
    uploadLoad: "/mga/componentUpload",
    getCompoentDetails: "/mga/component",
    deleteComponentDetails: "/mga/component",
    ashraeBuildingType: "/mga/ashraeBuildingType",
    defaultComponentValue: "/mga/getComponentDefaults",
    pvIncentive: "/mga/incentives",
    getScope: "/emb/auth/getScope",
    runSimulation: "/mga/triggerSimulation",
    simulationStatus: "/mga/simulationStatus",
    simulationData: "/mga/simulationData",
    assetsListAPI: "/mga/assetsList",
    defaultAssetsAttributes: "/mga/asset-default-attributes",
    assetsTypeAPI: "/mga/assetsType",
    saveAssetsAPI: "/mga/saveAssets",
    getAssetByIdAPI: "/mga/assetsById",
    getAssetCatalogue: "/mga/getAssetCatalogue",
    getProfile: "/mga/getProfile",
    getTimeSeriesData: "mga/getTimeSeriesScenario",
    getImportTemplate: "/mga/getImportTemplate",
    removeComponent: "/mga/component",
    getComponentSensitivityParams: "/mga/getComponentSensitivityParams",
    saveProjectSensitivity: "/mga/saveProjectSensitivity",
    getProjectSensitivity: "/mga/getProjectSensitivity",
    getPvProfile: "/mga/getPvProfile",
    getSensitivityResultNames: "/mga/getSensitivityResultNames",
    genabilityTariffList: "/mga/genabilityTariffList",
    singleGenabilityTariff: "/mga/singleGenabilityTariff",
    getSensitivityScenarioData: "/mga/sensitivityScenarioData",
    saveSensitivityScenarioData: "/mga/saveSensitivityScenarioData",
    uploadAndFetchDynamicTariff: "/mga/uploadAndFetchDynamicTariff",
    kpiFactors:"/mga/kpiFactors",
    saveKpiFactors:"/mga/saveKpiFactors",
    createDesignVersion: "/mga/createOrCopyVersion/project/{projectId}/design/{designId}/version/{designVersionId}",
    cloneVersion: "/mga/createOrCopyVersion/project/{projectId}/design/{designId}/version/{designVersionId}",
    deleteVersion:"/mga/deleteVersion",
    deleteProject: "/mga/deleteProject",
    uploadResultImages: '/mga/uploadResultImages',
    report: '/mga/report',
    shareProject: '/mga/shareProject',
    copyProject: '/mga/copyProject',
    getSharedProject: '/mga/getSharedProject',
    contextMenu:'/mga/contextMenu',
    createDemoProject:'/mga/createDemoProject',
    getTariffRawData: "/mga/getTariffRawData",
    myTariffTemplates: "/mga/myTariffTemplates",
    tariffTemplate: "/mga/tariffTemplate/{templateId}",
    deleteTariffTemplate: "/mga/deleteTariffTemplate/{templateId}",
    createUpdateTariffTemplate: "/mga/createUpdateTariffTemplate",
    exportTariffConfiguration: "/mga/exportTariffConfiguration",

    // Ticket Management
    getAllTickets: "/mga/getAllTickets",

    submitTicket:"/mga/submitTicket",
    getTicketId:'/mga/getTicket/{ticketId}',
    saveComments:'/mga/saveComments/{ticketId}',
    closeTicket:'/mga/closeTicket/{ticketId}',
  },
};
export default API_CONFIG;
